import { ChangeEvent } from "react";
import { IPoliceman } from "interfaces/Policeman";
import { AutoComplete } from "components/Autocomplete";
import * as S from "./styles";
import { ToggleButton } from "components/ToggleButton";
import Input from "components/Input";
import Button from "components/Button";
import PolicemanTabMap from "./PolicemanTabMap";
import { usePolicemanTab } from "./usePolicemanTab";
import { PolicemanRow } from "./PolicemanRow";

type PolicemanSelectOption = {
  value: IPoliceman
  label: string
}

export default function PolicemanTab() {
  const {
    registerPoliceman,
    setRegisterPoliceman,
    onlinePolicemen,
    registerPolicemanData,
    mapCoords,
    setRegisterPolicemanData,
    handleAddPoliceman,
    policemanArray,
    superficialPolicemanArray,
    handleAssociatePoliceman,
    associationSending,
    setSelectedPoliceman,
    removePolicemanByName
  } = usePolicemanTab()

  const policemanSelectOptions = onlinePolicemen.map((policemanOnline) => ({
    label: policemanOnline.user.name,
    value: policemanOnline
  }))

  return (
    <S.Wrapper data-cy="policeman-tab-map">
      <S.LeftContent>
        <S.AutoCompleteContainer>
          <ToggleButton
            response={registerPoliceman}
            label="Encontrou o agente registrado?"
            leftClick={() => setRegisterPoliceman(false)}
            rightClick={() => setRegisterPoliceman(true)}
          />
          {!registerPoliceman && (
            <AutoComplete
              id="pr"
              isDisabled={registerPoliceman}
              label="Selecione um pronta-resposta"
              noOptionsMessage={() => 'Nenhum pronta-resposta registrado no raio da ocorrencia'}
              placeholder="Selecione um pronta-resposta"
              options={policemanSelectOptions}
              onChange={(selected) => {
                const policemanData = (selected as PolicemanSelectOption).value
                setSelectedPoliceman(policemanData)
              }}
            />
          )}
          <Button
            title="Adicionar"
            onClick={handleAddPoliceman}
          />
        </S.AutoCompleteContainer>

        {!registerPoliceman && <PolicemanTabMap position={mapCoords} />}

        {registerPoliceman && (
          <S.RegisterContainer>
            <S.Header>
              <h3>Registrar um pronta-resposta para essa ocorrência</h3>
              <span>
                Você pode cadastrar um agente avulso para atuar nessa ocorrência
                fora do aplicativo.
              </span>
            </S.Header>

            <S.RegisterContent>
              <Input
                containerClassName="register-input-container"
                label="Nome completo do pronta-resposta"
                id="policemanName"
                name="policemanName"
                type="text"
                value={registerPolicemanData.name}
                disabled={!registerPoliceman}
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  setRegisterPolicemanData((prev) => ({
                    ...prev,
                    name: event.target.value,
                  }))
                }
                required
              />
              <Input
                containerClassName="register-input-container"
                label="Telefone para contato"
                id="policemanPhone"
                name="policemanPhone"
                type="text"
                value={registerPolicemanData.phoneNumber}
                disabled={!registerPoliceman}
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  setRegisterPolicemanData((prev) => ({
                    ...prev,
                    phoneNumber: event.target.value,
                  }))
                }
                required
              />
            </S.RegisterContent>
          </S.RegisterContainer>
        )}

        <Button
          title="Associar pronta(s) resposta(s)"
          onClick={handleAssociatePoliceman}
          disabled={associationSending}
          className="associate-btn"
        />
      </S.LeftContent>
      <S.RightContent>
        <h2>Prontas respostas selecionados</h2>

        <div className="selected-policemen-container">
          {policemanArray.map((item) => (
            <PolicemanRow
              key={item.user.id}
              name={item.user.name}
              isRegistered
              onTrashClick={removePolicemanByName}
            />
          ))}

          {superficialPolicemanArray.map((item) => (
            <PolicemanRow
              key={item.name + item.phoneNumber}
              name={item.name}
              isRegistered={false}
              onTrashClick={removePolicemanByName}
            />
          ))}
        </div>
      </S.RightContent>
    </S.Wrapper>
  );
}
